// @ts-nocheck
import { Enveloper } from "./enveloper.js";
import { EnvelopeControlRegister } from "./registers/envelope-control-registers.js";
import { HighOrderFrequencyRegister } from "./registers/high-order-frequency-registers.js";
import { SimpleByteRegister } from "../helpers/simple-byte-register.js";
export class Sound2 {
    dutyCycles = [
        [0, 0, 0, 0, 0, 0, 0, 1], // 12.5 %
        [1, 0, 0, 0, 0, 0, 0, 1], // 25 %
        [1, 0, 0, 0, 0, 1, 1, 1], // 50 %
        [0, 1, 1, 1, 1, 1, 1, 0], // 75 %
    ];
    positionInDutyCycle = 0;
    frequencyTimer = 0;
    frequencyPeriod = 0;
    lengthTimer = 0;
    enveloper = new Enveloper();
    volume = 0;
    nr21LengthAndDutyCycle = new SimpleByteRegister(0xff16);
    nr22EnvelopeControl = new EnvelopeControlRegister(0xff17);
    nr23LowOrderFrequency = new SimpleByteRegister(0xff18);
    nr24HighOrderFrequency = new HighOrderFrequencyRegister(0xff19);
    isActive = false;
    // Live channel-on status for NR52 ($FF26) bit 1. See Sound1.isOn.
    get isOn() {
        return this.isActive;
    }
    writeNr24(value) {
        this.nr24HighOrderFrequency.value = value;
        if ((value & 0x80) !== 0) {
            this.playSound();
        }
    }
    // NR22 ($FF17) write. A DAC-disabling value (top 5 bits clear) disables the
    // channel so NR52's status bit reflects it. See Sound1.writeNr12.
    writeNr22(value) {
        this.nr22EnvelopeControl.value = value;
        if (!this.nr22EnvelopeControl.isDacEnabled) {
            this.isActive = false;
        }
    }
    // Power-off clears every channel register and silences the channel.
    powerOff() {
        this.isActive = false;
        this.nr21LengthAndDutyCycle.value = 0;
        this.nr22EnvelopeControl.value = 0;
        this.nr23LowOrderFrequency.value = 0;
        this.nr24HighOrderFrequency.value = 0;
    }
    tick(cycles) {
        this.frequencyTimer -= cycles; // count down the frequency timer
        if (this.frequencyTimer <= 0) {
            this.frequencyTimer += this.frequencyPeriod; // reload timer with the current frequency period
            this.positionInDutyCycle = (this.positionInDutyCycle + 1) % 8; // advance to next value in current duty cycle, reset to 0 at 8 to loop back
        }
    }
    playSound() {
        // Enable channel
        this.isActive = true;
        // Initialize frequency
        this.frequencyPeriod = this.getFrequencyPeriod();
        this.frequencyTimer = this.frequencyPeriod;
        // Initialize envelope
        this.volume = this.nr22EnvelopeControl.initialVolume;
        this.enveloper.initializeTimer(this.nr22EnvelopeControl.lengthOfEnvelopeStep);
        // Initialize length. Parenthesize the mask: `64 - value & 0x3f` parses as
        // `(64 - value) & 0x3f` (- binds tighter than &), which yields 0 instead
        // of 64 when the length data is 0 — a full-length note would then never
        // expire. Sound1/3/4 already mask the value first; match them.
        this.lengthTimer = 64 - (this.nr21LengthAndDutyCycle.value & 0b111111);
        // A trigger with the DAC off does not enable the channel.
        if (!this.nr22EnvelopeControl.isDacEnabled) {
            this.isActive = false;
        }
    }
    clockLength() {
        if (!this.nr24HighOrderFrequency.isContinuousSelection) {
            this.lengthTimer--;
            if (this.lengthTimer === 0) {
                this.isActive = false;
            }
        }
    }
    clockVolume() {
        this.volume = this.enveloper.clockVolume(this.volume, this.nr22EnvelopeControl);
    }
    getSample() {
        if (!this.nr22EnvelopeControl.isDacEnabled || !this.isActive) {
            return 0;
        }
        const sample = this.dutyCycles[this.nr21LengthAndDutyCycle.value >> 6][this.positionInDutyCycle];
        const volumeAdjustedSample = sample * this.volume;
        return volumeAdjustedSample / 15; // TODO: Revisit the proper volume controls of / 7.5 -1 to get a range of 1 to -1
    }
    getFrequencyPeriod() {
        const rawValue = this.nr23LowOrderFrequency.value | (this.nr24HighOrderFrequency.highOrderFrequencyData << 8);
        return ((2048 - rawValue) * 4);
    }
}
//# sourceMappingURL=sound-2.js.map